import { gql, useMutation } from '@apollo/client';

// Herkunft (First Touch) an der Company nachtragen; der Server fuellt nur leere
// Spalten. Primaer laeuft die Herkunft ueber createUser (utils/attribution.ts).
const UPDATE_UTM_PARAMS = gql`
  mutation UpdateUtmParams($utmParams: String, $gclid: String, $landingPage: String, $referrer: String) {
    updateUtmParams(utmParams: $utmParams, gclid: $gclid, landingPage: $landingPage, referrer: $referrer)
  }
`;

export interface UpdateUtmParamsInput {
  utmParams?: string;
  gclid?: string;
  landingPage?: string;
  referrer?: string;
}

export interface UpdateUtmParamsResult {
  updateUtmParams: boolean;
}

export function useUpdateUtmParamsMutation() {
  return useMutation<UpdateUtmParamsResult, UpdateUtmParamsInput>(UPDATE_UTM_PARAMS, {});
}
